// remove later
export const availableRailOperators = [
	{ name: 'GWR', value: 'GWR' },
	{ name: 'Hull', value: 'Hull' },
	{ name: 'Lumo', value: 'Lumo' },
	{ name: 'SWR', value: 'SWR' },
];

export const smartCardsMock = [
	{
		id: '1',
		smartCardNumber: '235235 4322 1245 1111',
		nickName: 'John',
		status: true,
	},
	{
		id: '2',
		smartCardNumber: '235235 4322 1245 2222',
		nickName: 'Doe',
		status: false,
	},
	{
		id: '3',
		smartCardNumber: '235235 4322 1245 3333',
		nickName: 'Test',
		status: true,
	},
];
